var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('share-frame',{staticClass:"dd-celebrate-frame",attrs:{"backgroundColor":_vm.backgroundColor,"logo-color":"white"}},[_c('d-d-celebrate-share-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }